import { Box, Skeleton } from '@mui/material';
import PeriodFilter from '@/components/Base/PeriodFilter';
import React, { useEffect, useState } from 'react';
import { groupBy } from 'lodash';
import { useConsolidationScoreMovimentacaoEscolar } from './api/getConsolidationScoreMovimentacaoEscolar';
import ScoreMovimentacaoEscolarChart from '@/features/dashboard/components/ScoreMovimentacaoEscolarChart.tsx';
import LoadingChart from '@/features/dashboard/components/LoadingChart';

const ScoreMovimentacaoEscolar = ({ year: yearProp }: { year?: number }) => {
  const { data, isFetched, isFetching } = useConsolidationScoreMovimentacaoEscolar(yearProp);
  const listYears = Object
    .keys(groupBy(data, 'ano'))
    .map((item) => Number(item))
    .sort((a, b) => b - a);

  const [year, setYear] = useState<number | null>(null);

  useEffect(() => {
    if (isFetched && listYears.length) {
      setYear(listYears[0]);
    }
  }, [isFetched, listYears]);

  const onApplyFilter = (selectedYear) => {
    setYear(selectedYear);
  };

  return (
    <>
      <LoadingChart loading={isFetching} />

      {
        data?.length && (
          <ScoreMovimentacaoEscolarChart
            title={'Saídas X entradas de alunos da instituição'}
            lineColor={['rgba(224, 74, 76, 1)', '#15AB51']}
            data={data}
          />
        )
      }

      {
        isFetched && (
          <Box marginTop={'10px'}>
            <PeriodFilter year={year} years={listYears} onApplyFilter={onApplyFilter} />
          </Box>
        )
      }
    </>
  );
};

export default ScoreMovimentacaoEscolar;
